export default {
    common: {
        cancel: "Cancel",
        save: "Save",
        close: "close",
        dismiss: "Dismiss",
        loading: "Loading...",
        notSet: "Not set",
        unknown: "Unknown",
        edit: "Edit",
        delete: "Delete",
        confirm: "Confirm",
        back: "Back",
        next: "Next",
        yes: "Yes",
        no: "No",
        ok: "OK",
        or: "or",
        and: "and",
        name: "Name",
        cost: "Cost",
        access: "Access",
        titles: "Titles",
        scenario: "Scenario",
        search: "Search",
        update: "Update",
        download: "Download",
        submit: "Submit",
        required: "This field is required.",
        invalidEmail: "This email isn't valid.",
        personalEmail: "This looks like a personal email address.",
        somethingWentWrong: "Sorry, something went wrong",
        copy: "Copy",
        create: "Create",
        rename: "Rename",
        open: "Open",
        send: "send",
        new: "New",
        info: "Info",
        remove: "Remove",
        title: "Title",
        of: "of",
        clickToLearnMore: "Click to learn more.",
    },

    nav: {
        loadingInstitution: "Loading institution...",
        currentInstitution: "Current institution:",
        currentConsortium: "Current consortium:",
        otherOrganizations: "Other organizations ({count})",
        otherInstitutions: "Other institutions ({count})",
        consortium: "consortium",
        institution: "institution",
        loadingPackage: "Loading package...",
        currentPackage: "Current package:",
        otherPackages: "Other packages ({count})",
        currentScenario: "Current scenario:",
        otherScenarios: "Other scenarios ({count})",
        loadingScenario: "Loading scenario...",
        consortialFeeder: "consortial feeder",
        about: "About",
        learn: "Learn",
        docs: "Docs",
        webinars: "Webinars",
        documentation: "Documentation",
        sendFeedback: "Send Feedback",
        signedInAs: "You're signed in as",
        adminDashboard: "Admin dashboard",
        yourAccount: "Your account",
        help: "Help",
        logIn: "Log in",
        logOut: "Log out",
        support: "Support",
    },

    footer: {
        team: "Team",
        press: "Press",
        contact: "Contact",
        twitter: "Twitter",
        sourceCode: "Source code",
        watchVideo: "Watch video",
        caseStudies: "Case studies",
        purchase: "Purchase",
        logIn: "Log in",
        termsOfUse: "Terms of Use",
        privacyPolicy: "Privacy policy",
        madeWith: "Unsub is made with ❤︎ by",
        withSupport: "with generous support from",
    },

    currency: {
        selectedCurrency: "Selected Currency",
        currencyUsedEverywhere: "Your selected currency is used in many places throughout Unsub.",
        usDollars: "US Dollars (USD)",
        ukPounds: "UK Pounds Sterling (GBP)",
        japaneseYen: "Japanese Yen (JPY)",
        changeCurrency: "Change currency",
        selectCurrency: "Select currency",
        willSetCurrency: "This will set your currency {currency}.",
        confirmChangeCurrency: "Are you sure you want to change currency to {currency}?",
        noConversion: "Changing currency doesn't convert from one currency to another.",
        updateCostsNote: "If you make the change, don't forget to edit your package Big Deal Cost and scenario ILL Transaction Cost parameter to new values denominated in {currency}.",
        replaceCustomPricelist: "You'll also need to replace your custom pricelist.",
        importantLabel: "Important:",
        importantNote: "changing currency doesn't convert from one currency to another. If you change currency, don't forget to update costs you've already entered, replacing them with ones denominated in your new currency. Specifically, you'll need to edit your package Big Deal Cost and scenario ILL Transaction Cost parameter.",
        changeTo: "Change to {currency}",
        noteLabel: "Note:",
        jpyNote: "For JPY, journals without custom JPY prices will be automatically converted from USD using the MURC Monthly Average TTS exchange rate, which is updated at the beginning of each month.",
        currencyChanged: "currency changed to {currency}",
    },

    bigDeal: {
        annualCost: "Big Deal annual cost",
        annualCostDescription: "Enter the annual cost of your Big Deal from this publisher(s). If you don't have a Big Deal, enter your total annual spend on journals from this publisher(s).",
        annualCostLabel: "Annual cost",
        annualCostIncrease: "Big Deal annual cost increase (%)",
        annualCostIncreaseDescription: "Enter the annual growth in the cost of your Big Deal. As above, if you don't have a Big Deal, just estimate the growth of your total spending on titles from this publisher(s).",
        annualIncrease: "Annual increase",
        fiveYearAnnualCost: "Big Deal 5-year annual cost",
        fiveYearAnnualCostDescription: "This is your estimated annual package spend over the next five years, if you renewed your Big Deal.",
        fiveYearLabel: "5-yr annual cost",
        editBigDealCost: "Edit Big Deal cost",
        editBigDealCostIncrease: "Edit Big Deal increase",
        annualCostInput: "Annual cost ({currency})",
        annualIncreaseInput: "Annual increase (%)",
        editSuccessful: "Edit successful.",
    },

    scenarioView: {
        recalculating: "Scenario recalculating...",
        recalculatingDescription: "This consortial scenario is currently locked while we recalculate the forecast. This can take up to one hour.",
        emailNotification: "We'll send an email to {email} when the update is complete (don't forget to check your spam folder).",
        annualCost: "Annual cost",
        projectedAnnualCost: "Projected annual cost",
        projectedAccess: "Projected Access",
        costExplanation: "Over the next five years, your library will pay {cost} in this scenario. That's {percent} of what you'd pay if you kept your Big Deal.",
        accessExplanation: "Over the next five years, library users will be able to easily access {percent} of requests (via PTA, Open Access, title-by-title subscription, or ILL).",
        fiveYearForecast: "5yr Forecast",
        usageFulfillment: "Usage fulfillment",
        selectJournals: "Select journals",
        newScenario: "New scenario",
        consortialProposal: "This is a Consortial Proposal scenario. The parameters and core title-by-title subscriptions are preset by consortial staff. Your mission is to provide feedback on this proposed scenario.",
        displayJournalsAs: "Display journals as:",
        journalSubscribed: "Journal subscribed",
        journalUnsubscribed: "Journal unsubscribed",
        journalsSubscribed: "Journals subscribed",
        journalsUnsubscribed: "Journals unsubscribed",
        selected: "selected",
        subscribeAll: "Subscribe to all {count} selected journals.",
        unsubscribeAll: "Unsubscribe to all {count} selected journals.",
    },

    params: {
        showParameterDetails: "Show parameter details",
        costs: "Costs",
        ill: "ILL",
        fulfillmentSources: "Fulfillment sources",
        citationAuthorship: "Citation and authorship",
        titleByTitleGrowth: "Title-by-title subscription cost growth",
        titleByTitleGrowthDescr: "The annual percent increase you expect in title-by-title subscription prices (literature suggests 8%).",
        contentFee: "Title-by-title 'content fee'",
        contentFeeDescr: "A content fee charged by publishers when buying subscriptions title-by-title, above whatever is included in your current package price (literature suggests 5.7% for subscriptions).",
        illTransactionCost: "ILL transaction cost",
        illTransactionCostDescr: "The cost of an ILL request for your institution (literature suggests $17 is average).",
        illRequestRate: "ILL Request Rate",
        illRequestRateDescr: "The percent of turnaways that will result in an ILL request. Our extensive literature review suggests 5% is a conservative estimate.",
        includeBronzeOA: "Include Bronze OA",
        includeBronzeOADescr: "Include Bronze OA as a type of fulfillment.",
        permitNonPeerReviewed: "Permit non-peer-reviewed versions",
        permitNonPeerReviewedDescr: "For Green OA, allow submitted versions as a type of fulfillment.",
        includeResearchGate: "Include ResearchGate-hosted content",
        includeResearchGateDescr: "Include ResearchGate and other Academic Social Networks as a fulfillment source.",
        authorshipWeight: "Institutional authorship weight",
        authorshipWeightDescr: "A paper authored by someone in your institution contributes this many download-equivalent points to the Usage of the journal.",
        citationWeight: "Institutional citation weight",
        citationWeightDescr: "A citation from someone in your institution contributes this many download-equivalent points to the Usage of the journal.",
        couldTakeAWhile: "This could take a while...",
        recalcWarning: "Changing this parameter will recalculate the forecast, which can take up to 60 minutes. You won't be able to view or edit this scenario during that time.",
        recalcEmailNotice: "We'll send an email to {email} when we're done (don't forget to check your spam).",
        saveAndWait: "Save and wait",
        settingUpdated: "Setting updated",
        settingsReset: "Settings reset",
        confirmReset: "Confirm reset",
        confirmResetText: "Are you sure you want to reset all settings for this scenario back their default values? This can't be undone, so it's a good idea to save a backup copy first.",
        yesResetAll: "Yes, reset all settings",
    },

    columns: {
        publisher: "Publisher",
        publisherShort: "Publisher short",
        costPerUse: "Cost per use",
        rankByCPU: "Rank by CPU",
        cost: "Cost",
        usage: "Usage",
        instantUsagePercent: "Instant Usage Percent",
        freeInstantUsagePercent: "Free Instant Usage Percent",
        subscriptionCost: "Subscription Cost",
        illCost: "ILL Cost",
        subscriptionMinusIll: "Subscription minus ILL Cost",
        downloads: "Downloads",
        citations: "Citations to papers",
        authorships: "Authored papers",
        pta: "PTA (Post-Termination Access)",
        baselineAccess: "Baseline access",
        sortAsc: "Sort Asc",
        sortDesc: "Sort Desc",
        addRemoveColumns: "Add/remove columns",
        noJournalsMatched: "No journals matched your search.",
    },

    columnGroups: {
        metadata: "Metadata",
        costEffectiveness: "Cost Effectiveness",
        costs: "Costs",
        openAccess: "Open Access",
        fulfillment: "Fulfillment",
        impact: "Impact",
    },

    segments: {
        unknown: "Unknown",
        accessUnknown: "Access unknown",
        ill: "ILL",
        interLibraryLoan: "Inter-Library Loan",
        subscription: "Subscription",
        titleByTitle: "Title-by-title subscription",
        oa: "Open Access",
        backfile: "PTA",
        postTermination: "Post-Termination Access (Backfile)",
        savings: "Savings",
        costSavings: "Cost savings",
        requested: "Requested",
        requestedByMembers: "Requested by consortium members",
        titleByTitleCost: "Title-by-title subscription cost",
        requestedCost: "Requested subscription cost",
    },

    segmentDesc: {
        costSavings: "This is your annual savings over the next five years, based on the current model.",
        costSubr: "This is your subscription spend over the next five years, based on the current model.",
        costRequested: "This is your <em>requested</em> subscription spend over the next five years, based on the current model.",
        costIll: "This is your ILL spend over the next five years, based on the current model.",
        usageTurnaway: "This is the percentage of usage that can't be fulfilled by OA or the library, and won't generate an ILL request. Current research suggests that in these cases, users will email colleagues for copies, visit Sci-Hub, or find alternative articles; however, the details of user behavior in these cases are still poorly understood.",
        usageIll: "This is the percentage of usage that can't be fulfilled by any free source or subscription, and goes on to generate an ILL request.",
        usageSubr: "This is the percentage of usage that can't be fulfilled by any free source, but can be fulfilled by one of your title-by-title subscriptions.",
        usageRequested: "This is the percentage of usage that can't be fulfilled by any free source, but could be fulfilled by your <em>requested</em> title-by-title subscriptions.",
        usageBackfile: "This is the percentage of usage that can't be fulfilled by Open Access, but can be fulfilled under your PTA rights.",
        usageOa: "This is the percentage of usage that can be fulfilled by online Open Access.",
    },

    publisher: {
        setup: "Setup",
        scenarios: "Forecast scenarios",
        editDetails: "Edit Details",
        apc: "APC",
        loadingPackage: "Loading package",
        package: "Package",
        noDescription: "No description",
        requiredData: "Required data",
        recommendedData: "Recommended data",
        optionalData: "Optional data",
        diagnosticData: "Diagnostic data",
        counter: "COUNTER",
        pricelist: "Journal pricelist",
        bigDealCosts: "Big Deal costs",
        ptaAccess: "PTA (Post-Termination Access)",
        journalFilter: "Journal filter",
        excludedTitles: "Excluded titles",
        newPackage: "New package",
        addPackage: "Add subscription package",
        packageName: "Package display name",
        description: "Description",
        packageCreated: "Package created.",
        packageDeleted: "Package deleted.",
        packageRenamed: "Package renamed.",
        descriptionEdited: "Description edited.",
        editPackageName: "Edit package name",
        editDescription: "Edit description",
        deletePackage: "Delete package",
        deletePackageConfirm: "Are you sure you want to delete this package?",
        yesDeleteIt: "Yes, delete it",
        renamePackage: "Rename Package",
        newPackageName: "New package name",
        consortialFeederAlert: "This is a Consortial Feeder package. It exists to provide a data source for your consortium's central Unsub dashboard.",
        consortialProposalAlert: "This is a Consortial Proposal package. It contains a list of cancellation scenarios proposed by your consortium.",
        makeCopy: "Make a copy",
        rename: "Rename",
    },

    publisherFile: {
        processing: "{name} processing...",
        processingDescription: "This may take up to ten minutes.",
        uploadedWithError: "{name} uploaded but has error!",
        errorDescription: "There was something wrong with the file, and it can't be used. Please delete it, correct the error, and try again.",
        uploaded: "{name} uploaded.",
        extractedRows: "We extracted {count} rows of useful data. This data is now in use for the scenarios belonging to this package.",
        selectFile: "Select your {name} file",
        uploadFailed: "Upload failed",
        fileUploaded: "File uploaded.",
        fileDeleted: "File deleted.",
        deleteFile: "Delete file",
        deleteFileConfirm: "Are you sure you want to delete this file?",
        downloaded: "{name} downloaded.",
        unrecognizedFileExtension: "Unrecognized file extension",
        fileUploadFailed: "File upload failed.",
        demoCannotDelete: "Demo accounts can't delete data.",
    },

    institution: {
        demoRestricted: "This is a demo institution; some functionality is restricted.",
        purchaseFullAccount: "Purchase full account",
        packages: "Packages",
        users: "Users",
        rorIds: "ROR IDs",
        apcReport: "APC Report",
        consortialFeeders: "Consortial feeders",
        consortialProposals: "Consortial proposals",
        newGroupMember: "New group member",
        addGroupMember: "Add group member",
        email: "Email",
        role: "Role",
        welcomeEmailNote: "When you create this user, we'll send them an automated welcome email.",
        createGroupMember: "Create group member",
        userCreated: "New user created, and welcome email sent.",
        userRoleUpdated: "User role updated.",
        consortia: "Consortia",
        demoCannotAddPackages: "Demo profiles can't add packages.",
        consortialFeederDataSource: "These function exclusively as a data source for your consortium's central Unsub dashboard.",
        jiscNotRequesting: "Jisc is not currently requesting feedback on any scenarios via Unsub",
        you: "(you)",
        selectRole: "Select role",
        consortium: "Consortium",
        institutionLabel: "Institution",
    },

    login: {
        notSupportedMobile: "Not supported on mobile",
        notSupportedMobileDesc: "Sorry, login is not currently supported on mobile devices. Please log in using your desktop or laptop.",
        signIn: "Sign in",
        step1: "Step 1",
        step2of2: "Step 2 of 2",
        emailLabel: "Email",
        passwordLabel: "Password",
        forgotPassword: "Forgot password?",
        logIn: "Log in",
        accountNotFound: "Sorry, we couldn't find that account.",
        passwordIncorrect: "Password incorrect",
    },

    user: {
        myAccount: "My Account",
        demoRestricted: "This is a demo account; some functionality is restricted.",
        yourAccount: "Your Account",
        yourName: "Your name",
        yourEmail: "Your email",
        yourPassword: "Your password",
        noneSet: "None set",
        emailTaken: "Sorry, that email is taken.",
        updated: "{field} updated",
        userLabel: "User",
        settings: "Settings",
    },

    recoverPassword: {
        title: "Recover Password",
        description: "Don't worry, happens to the best of us. We can send you an email with a link allowing you to reset your password.",
        accountEmail: "Account email",
        sendLink: "Email me a recovery link",
        emailSent: "Recovery email sent",
        emailSentDesc: "We've sent an email with a link that can be used to reset your password. It should arrive in a minute or two (don't forget to check your spam folder).",
    },

    resetPassword: {
        changePassword: "Change Password",
        newPassword: "New password",
        changeButton: "Change password",
        success: "Password Changed!",
        successDesc: "Your password has been successfully updated, and now you can log in!",
        error: "Password Update Error",
        errorDesc: "Sorry, we couldn't update your password.",
        requestAnother: "Request another reset email",
    },

    scenarioEdit: {
        copyScenario: "Copy this scenario",
        nameForNewScenario: "Name for the new scenario:",
        createNewScenario: "Create new scenario",
        newScenarioWarning: "New scenarios are created quickly, but it takes up to one hour before they are fully provisioned and ready for use.",
        newScenarioEmail: "We'll send an email to {email} when the scenario is ready to use (don't forget to check your spam).",
        copyInstead: "If don't want to wait, you can copy an existing scenario instead...that only takes a few seconds.",
        renameScenario: "Rename this scenario",
        newName: "New name:",
        deleteScenario: "Delete this scenario",
        deleteScenarioConfirm: "Are you sure you want to delete this scenario? This can't be undone.",
        openScenario: "Open scenario",
        scenarioLoading: "Scenario loading...",
        scenarioCopied: "Scenario copied",
        scenarioRenamed: "Scenario renamed",
        scenarioDeleted: "Scenario deleted",
    },

    scenarioExport: {
        exportDescription: "You can export all of the data in this scenario as a CSV file. You can find documentation for the column names here.",
        exportExtender: "To further explore and visualize your exported data, check out Unsub Extender, a free third-party tool created by Eric Schares, a librarian at Iowa State University.",
        memberSubRequests: "Member subscription requests (beta)",
        memberSubRequestsDesc: "Pull a list of subscriptions that your member institutions have requested you include in this scenario.",
        downloadViaEmail: "Download (via email)",
        youllGetEmail: "You'll get an email soon",
    },

    scenarioMenu: {
        table: "Table",
        histogram: "Histogram",
        export: "Export",
        downloadSpreadsheet: "Download as spreadsheet",
        yourApiKey: "Your API key",
        publicSummary: "Public summary webpage",
        apiKeyDescription: "The public API doesn't need a key, but this unique key allows you to access your account data via the API as well:",
        publicSummaryDescription: "If you enable this page, you can share this scenario at a public URL. This can be useful for sharing your forecasts with administrators and faculty.",
        enablePublicSummary: "Enable public summary page",
        underConstruction: "Sorry, this feature is still under construction.",
        knowledgeBase: "Knowledge base",
        contactUs: "Contact us",
        view: "View",
        showBarGraphs: "Show bar graphs",
        costsByType: "Costs by type",
        usageByType: "Usage by type",
        subscriptions: "Subscriptions",
        unsubscribeAll: "Unsubscribe all",
        subscribeAll: "Subscribe all",
        unsubscribeToAll: "Unsubscribe to all {count} journals",
        subscribeToAll: "Subscribe to all {count} journals",
        parameters: "Parameters",
        resetAll: "Reset all",
    },

    scenarioInstitutions: {
        institutions: "Institutions",
        searchInstitutions: "Search institutions",
        selectAtLeastOne: "Please select at least one institution.",
        institutionsUpdated: "Institutions updated.",
        yourMemberInstitutions: "Your member institutions",
        institutionsSelected: "institutions selected",
        mustSelectOne: "You must select at least one institution",
        memberInstitutions: "Member Institutions",
        showingDataFrom: "Showing data from",
    },

    scenarioPushPull: {
        pushPull: "Push/pull",
        sendScenario: "Send scenario to members",
        sendDescription: "member institutions, and you're about to send a copy of this scenario to them.",
        scenarioShared: "Scenario shared and notifications sent.",
        searchByNameOrTags: "Search by name or tags",
        included: "Included",
        institutionName: "Institution name",
        sent: "Sent",
        lastChanged: "Last Changed",
        lastReturned: "Last Returned",
        sendToConsortium: "Send to consortium",
    },

    overview: {
        cpu: "CPU",
        subscribed: "Subscribed",
        notSubscribed: "Not subscribed",
        subscribedJournals: "Subscribed journals",
        requestedJournals: "Requested journals",
        overwriteCustom: "Overwrite custom subscription?",
        overwriteCustomDesc: "This will overwrite your custom title-by-title journals subscription(s), and automatically subscribe to the {count} journals with the lowest Cost Per Use. Are you sure you want to do that?",
        yepOverwrite: "Yep, overwrite it.",
        yearly: "yearly",
        projected: "Projected",
        journalsArrangedByCPU: "journals, arranged by Cost Per Use (CPU)",
        additionalJournalsCPU: "additional journals with CPU >",
        additionalJournalsNoUsage: "additional journals with no paywalled usage",
        ofBigDeal: "of Big Deal",
        fulfilledInstantly: "fulfilled instantly",
        uses: "Uses",
    },

    overviewDetail: {
        costParagraph1: "In this scenario, you cancel your Big Deal and then {subscriptions} to {subscribedCount} journals (leading to increased {illCosts} for the remaining {remainingCount} journals).",
        costParagraph2: "We can estimate the costs of both of these, based on our forecasting model and your custom configs. We project this scenario will cost the library {cost} over the next five years, which is {percent} of what you were spending on your Big Deal.",
        subscriptions: "purchase subscriptions",
        illCosts: "ILL costs",
        usageParagraph1: "Based on your COUNTER data and our forecasting model, we project that the {count} journals in this big deal will generate {usage} over the next five years.",
        usageParagraph2: "{percent} of these requests can be instantly fulfilled, with no inconvenience to users—either by {freeSources} (Open Access and Post-Termination Access rights) or via your {subscriptionLinks}",
        usageRequests: "requests for content (usage events)",
        freeSources: "free sources,",
        titleByTitleSubscriptions: "title-by-title journal subscriptions",
    },

    singleJournal: {
        journal: "journal",
        overview: "overview",
        institutions: "institutions",
        timelines: "timelines",
        journalMetadata: "Journal metadata",
        publisherLabel: "Publisher",
        subject: "Subject",
        issn: "ISSN",
        societyJournal: "Society journal",
        delayedOA: "Delayed OA",
        oaEmbargoLength: "OA embargo length",
        months: "months",
        ptaRights: "PTA (Post-Termination Access) rights",
        annualUsage: "Annual Usage",
        weightedOverallUses: "Weighted overall uses",
        paywalledUses: "Paywalled uses",
        annualCost: "Annual Cost",
        baseSubscriptionCost: "Base subscription cost",
        illCostLabel: "ILL cost",
        netSubscriptionCost: "Net subscription cost",
        costPerUseLabel: "Cost Per Use",
        loadingJournalDetail: "Loading Journal detail",
        loadingInstitutionDetail: "Loading Institution detail",
        subscribe: "Subscribe",
        unsubscribe: "Unsubscribe",
        request: "Request",
        unrequest: "Unrequest",
        journalRequested: "Journal requested",
        journalUnrequested: "Journal unrequested",
        fulfillment: "Fulfillment",
        impact: "Impact",
        subscriptionCostLabel: "Subscription cost",
        apiResponse: "API response",
        unsubscribed: "Unsubscribed",
        notes: "Notes:",
        downloadsWeight: "Downloads <br> @ 1x",
        citationsWeight: "Citations <br> @ {weight}x",
        authorshipsWeight: "Authorships <br> @ {weight}x",
        oaWithPercent: "Open Access ({percent}%)",
        backfileWithPercent: "Backfile ({percent}%)",
    },

    journalDetail: {
        type: "Type",
        usageProjectedAnnual: "Usage (projected annual)",
        usagePercent: "Usage (percent)",
        oaType: "OA Type",
        percentOfAllUsage: "Percent of all usage",
        rawProjectedAnnual: "Raw (projected annual)",
        weight: "Weight",
        usageContribution: "Usage contribution",
        costType: "Cost Type",
        costProjectedAnnual: "Cost (projected annual)",
        costTypePerPaidUse: "Cost-Type per paid use",
        researchGateEtc: "ResearchGate, etc.",
        green: "Green",
        hybrid: "Hybrid",
        bronze: "Bronze",
        total: "*Total*",
        downloadsLabel: "Downloads",
        citationsLabel: "Citations to papers in this journal",
        authorshipsLabel: "Authored papers in this journal",
        yourScenarioCost: "*Your scenario cost*",
        subscriptionByYear: "Subscription Cost By Year",
        illByYear: "ILL Cost By Year",
        subscriptionMinusIllByYear: "Subscription Minus ILL Cost By Year",
        noPaidUsage: "no paywalled usage",
        ptaNote: "PTA (Post-Termination Access) is only content that's not otherwise available as OA.",
        greenNote: "Green is only content that's not otherwise available as hybrid or bronze.",
        delayedOANote: "this journal makes back content available after an embargo of {months} months.",
        currentlySubscribed: "You are currently subscribed to this journal.",
        currentlyNotSubscribed: "You are currently not subscribed to this journal.",
    },

    apc: {
        articlePublicationCosts: "Article Publication Costs last year",
        totalApcExpenditure: "Total APC expenditure, Gold and Hybrid",
        apcLoading: "APC data loading...",
        apcDescription: "Authors from your institution paid an estimated {cost} in APCs (Article Processing Costs) last year. This sum includes APCs paid to gold and hybrid OA journals. When OpenAlex identifies your institution as the corresponding institution on an article, we attribute the full APC to you; when that information is not available, we fall back to an estimate that assumes each author was equally likely to be the corresponding author.",
        journalsPaidByAuthors: "{count} journals paid by authors from your institution",
        searchJournals: "Search journals",
    },

    dataFiles: {
        counter: "COUNTER",
        counterType: "COUNTER usage data",
        ptaDateRanges: "PTA date ranges",
        ptaType: "Date ranges where you have Post-Termination access",
        filterTitles: "Filter titles",
        filterType: "Titles to include in your package",
        pricelist: "Title-by-title pricelist",
        pricelistType: "Title-by-title subscription prices",
    },

    app: {
        notSupportedYet: "Sorry, that's not supported yet. Contact support@openalex.org for more info.",
        cantChangeInEditMode: "You can't change configs when you're in Edit Mode",
    },

    setup: {
        setupPrefix: "Setup:",
        requiredData: "Required data",
        recommendedData: "Recommended data",
        optionalData: "Optional data",
        diagnosticData: "Diagnostic data",
        fullyLoaded: "<strong>Fully loaded: </strong> This data is now being used in all forecast scenarios.",
        missingData: "<strong>Missing data: </strong> This data is required.",
        missingPricesNone: "You have no journals with missing price information.",
        missingPricesRequired: "<strong>Missing required data: </strong> There are ",
        missingPricesStill: "<strong>Still missing data: </strong> Although you've uploaded a custom pricelist, there remain",
        missingPricesSuffix: " journals with no price information. These are excluded from all forecasting. To fix, upload a new custom journal pricelist below, with price quotes for those missing titles.",
        viewMissingTitles: "View missing titles",
        journalsDownloaded: "Journals downloaded.",
        consortiumSetupNote: "Setup for consortial dashboards happens behind the scenes, via email or data imports from your member institution dashboards. If you have any questions about setup, please drop us a line at",
        counterVersion: "COUNTER version",
        counterVersionDescNoVersion: "This sets which type of COUNTER report you'll use. We recommend you use COUNTER 5 reports, which will generate more accurate forecasts.",
        counterVersionDescV4: "This sets which version of COUNTER report you're using. To edit, first delete the COUNTER 4 JR1 report that you've already uploaded.",
        counterVersionDescV5: "This sets which version of COUNTER report you're using. To edit, first delete the three COUNTER 5 reports that you've already uploaded.",
        counterReportFiles: "COUNTER report files",
        counter5Instructions: "For COUNTER 5 you'll need to upload three reports: your <strong>TR_J2, TR_J3,</strong> and <strong>TR_J4.</strong> Both COUNTER 5.0 and 5.1 formats are supported. Unsub requires all three files, in order to create your dashboard. Each file requires 3 or more rows of data (excluding headers). If you can not get a <strong>TR_J2</strong> file or the <strong>TR_J2</strong> file does not have any rows of data except the header rows you can download and use <a href=\"https://unsub-public.s3.amazonaws.com/TR_J2.csv\">this fake <strong>TR_J2</strong> file</a>. It should not affect your dashboard.",
        counter4Instructions: "For COUNTER 4, you'll need to upload a single file:",
        journalPricelist: "Journal pricelist",
        pricelistInstructions: "Upload a spreadsheet with a title-by-title price for each journal. The spreadsheet should have two columns: <strong>ISSN</strong> and <strong>Price</strong>. Accepted formats are:",
        pricelistFormats: "and",
        ptaFile: "Your PTA file",
        ptaInstructions: "Upload your PTA (Post-Termination Access) dates as a spreadsheet with one journal per row. The spreadsheet should have three columns: <strong>ISSN</strong>, <strong>Start date</strong>, and <strong>End date</strong>. For journals where the PTA is ongoing, just leave the <strong>End Date</strong> blank.",
        ptaFormats: "Accepted formats:",
        filterFile: "Your spreadsheet or KBART file",
        filterInstructions: "Upload your file as either a:",
        filterOption1: "Spreadsheet with one journal per row. The spreadsheet should have one column (<a target=\"_blank\" href=\"https://en.wikipedia.org/wiki/International_Standard_Serial_Number\">ISSN</a>).",
        filterOption2: "{kbartLink}",
        filterFormats: "Accepted file formats for both:",
        excludedDescription: "Some journals in your COUNTER reports are excluded from scenario forecasts for a <a href=\"https://docs.unsub.org/troubleshooting/why-dont-i-see-a-certain-title-in-my-dashboard\" target=\"_blank\">variety of reasons</a>. Here, you can download a report as a CSV file with those titles that are excluded, and for what reason(s) they are excluded. Read <a href=\"https://docs.unsub.org/how-to-guides/excluded-titles-report\" target=\"_blank\">the documentation</a> for more information.",
        excludedTitlesButton: "Excluded Titles",
        fiveYearCostDescription: "This is your estimated annual package spend over the next five years, if you renewed your Big Deal. It's generated automatically: we simply start with your base annual spend, compute its five-year compound growth as determined by your annual cost increase, and finally calculate a yearly average. This number is used to compute your potential annual savings under various cancellation scenarios.",
        ptaMissingWarning: "<strong>Missing data: </strong> Forecasts currently assume you have <em>zero PTA rights</em> for all titles. This is probably untrue, and so your forecasts are not very accurate.",
        filterOptionalMsg: "<strong>Optional data: </strong> You can filter all scenarios within this package to include only specific titles by providing a spreadsheet of ISSNs or a KBART file.",
        excludedDiagnosticMsg: "<strong>Download a report on the titles excluded from this package.</strong>",
        tabCounter: "COUNTER",
        tabPricelist: "Pricelist",
        tabPricelistLong: "Journal pricelist",
        tabCurrency: "Currency",
        tabBigDealCosts: "Big Deal costs",
        tabPta: "PTA",
        tabPtaLong: "PTA (Post-Termination Access)",
        tabFilter: "Filter",
        tabFilterLong: "Journal filter",
        tabExcludedTitles: "Excluded titles",
        priceCurrencyLabel: "Currency of price list",
        priceCurrencyDescription: "Select the currency of your uploaded price list. If it differs from your package currency, prices will be automatically converted using the TTS exchange rate.",
        priceCurrencySaved: "Price list currency saved.",
    },

    homepage: {
        tagline: "A better way to analyze your Big Deal.",
        description: "The Unsub dashboard helps you reevaluate your deal's value, and understand your cancellation options.",
        watchVideo: "Watch video",
        readCaseStudies: "Read case studies",
        usedIn: "Used in {count} large and small, including:",
        usedInLibraries: "500+ libraries",
        wantToLearnMore: "Want to learn more?",
        watchGuidedTour: "Watch our video guided tour.",
        guidedTourLabel: "Take the guided tour:",
        sellingPoint1Header: "See the big picture",
        sellingPoint1Text: "Account for overlap with Open Access and your Post-Termination Access rights, and layer in journal-level citation and authorship data from your faculty.",
        sellingPoint2Header: "Explore your options",
        sellingPoint2Text: "Explore different title-by-title subscription scenarios, and forecast the five-year impact on your library's costs and fulfillment.",
        sellingPoint3Header: "Save time",
        sellingPoint3Text: "Ditch the complex spreadsheets--just upload your COUNTER reports and PTA (Post-Termination Access) rights, and let Unsub do the rest.",
        usersLoveUnsub: "Users ❤︎ Unsub",
        testimonialIntro: "But you don't have to take our word for it! Here's a sample of feedback we've received:",
    },

    ror: {
        description: "A ROR ID is a unique ID (like an ISSN) for research institutions. We base your institutional citation and authorship counts on your institution's ROR ID(s).",
        demoRorId: "(demo ROR ID)",
        viewOnRor: "View record on www.ror.org",
    },

    apc: {
        description: "Download a report with estimates of your institution's APC spend on gold and hybrid open-access articles. When OpenAlex identifies your institution as the corresponding institution on an article, we attribute the full APC to you. When corresponding-institution information is not available, we fall back to an estimate that assumes each author on the article had an equal likelihood of being the corresponding author.",
        dataSource: "Articles are drawn from OpenAlex and priced individually using OpenAlex's per-article APC data, which now covers a wide range of publishers.",
        readDocs: "Read {link} for more information.",
        docsLinkText: "the documentation on the APC report",
    },

    warnings: {
        missingPerpetualAccess: "Missing PTA",
        missingPrices: "Missing Prices",
        missingCounterData: "Missing COUNTER",
        missingBigDealCosts: "Missing Big Deal costs",
        filteringTitles: "Journal Whitelist",
    },

    language: {
        label: "Language",
        en: "English",
        ja: "日本語",
    },
}
